import { render, staticRenderFns } from "./AcceptanceCriteria.vue?vue&type=template&id=0b303d9a&scoped=true&"
import script from "./AcceptanceCriteria.vue?vue&type=script&lang=js&"
export * from "./AcceptanceCriteria.vue?vue&type=script&lang=js&"
import style0 from "./AcceptanceCriteria.vue?vue&type=style&index=0&id=0b303d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b303d9a",
  null
  
)

export default component.exports